import { awardCategories2021, awardsBenefits2021, winners2021 } from './data';
import { Footer2021, Header2021, make2021Href, use2021Page } from './shared';

const Awards2021 = () => {
  const { lang } = use2021Page('Smart Living Partnership Awards 2021 - Awards');
  return (
    <>
      <Header2021 lang={lang} currentPath="awards" />
      <main>
        <div className="background-container" style={{ backgroundImage: 'url(/2021/images/awards.png)', marginTop: '8.1%', marginLeft: '-3px' }}>
          <img src="/2021/images/awards.png" style={{ visibility: 'hidden' }} alt="" />
        </div>
        <div className="winner-main-container background-container" style={{ backgroundImage: 'url(/2021/images/awards2.png)' }}>
          <img src="/2021/images/awards2.png" style={{ visibility: 'hidden' }} alt="" />
          <div className="background-info">
            <h1 className="award-category-title">{lang === 'zh' ? '獎項類別' : 'Award Category'}</h1>
            <p className="award-p">{lang === 'zh' ? '「2021智慧生活夥伴大獎」中共有12個獎項類別包括' : 'Smart Living Partnership Awards 2021 comprises of 12 award categories including'}</p>
            <div className="awards-category-container">
              {awardCategories2021.map((cat) => (
                <div key={cat.key}>
                  <div className="awards-bar">
                    <div className="icon"><div style={{ width: 70, height: 70, marginTop: '5%', marginLeft: '40%' }}><img src={`/2021/images/${cat.key}.png`} alt="" /></div></div>
                    <div className="title"><span>{lang === 'zh' ? cat.zh : cat.en}</span></div>
                    <div className="arrow"><div className="triangle-left"></div></div>
                  </div>
                  <div style={{ paddingTop: '1%', paddingBottom: '1%', boxShadow: '0 2px 8px #b2abb1', lineHeight: '1.5rem' }}>
                    {(winners2021[cat.key]?.[lang] || []).map((w) => (
                      <div style={{ display: 'flex' }} key={`${cat.key}-${w.id}`}>
                        <div style={{ fontWeight: 'bold', paddingLeft: '2%', width: '50%' }}>{w.award_name}</div>
                        <div style={{ width: '50%' }}>
                          &#8227; <a href={`/2021/portfolio.php?award=${cat.key}&winner=${w.id}${lang === 'zh' ? '&lang=zh' : ''}`} style={{ textDecoration: 'none' }}>{w.awardee}</a>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
              <h1><b>{lang === 'zh' ? '得獎者的裨益' : 'Benefits of the Awards'}</b></h1>
              <ul style={{ marginLeft: 0, listStyleImage: 'url(/2021/images/green_arrow.png)' }}>
                {awardsBenefits2021[lang].map((t) => <li className="awards-benefit" style={{ marginBottom: 10 }} key={t}>{t}</li>)}
              </ul>
              <p><a href={make2021Href('winners', lang)}>{lang === 'zh' ? '查看得獎名單' : 'View winners list'}</a></p>
            </div>
          </div>
        </div>
      </main>
      <Footer2021 lang={lang} />
    </>
  );
};

export default Awards2021;
